import React from "react";

const EditCartForm = ({ editForm, onChange, onSubmit, onCancel }) => {
  return (
    <form
      onSubmit={onSubmit}
      className="grid grid-cols-1 gap-4 p-6 bg-white rounded-lg shadow-lg w-[90%] max-w-2xl"
    >
      {["note"].map((field) => (
        <div key={field} className="flex flex-col">
          <label className="text-sm font-semibold capitalize text-black">{field}</label>
          <textarea
            type="text"
            name={field}
            value={editForm[field]} 
            onChange={onChange}
            required
            className="px-3 py-1 text-black bg-gray-100 border rounded-md"
          />
          
        </div>
      ))}

      <div className="flex justify-end col-span-2 mt-2 space-x-3">
        <button type="button" onClick={onCancel} className="px-4 py-1 text-black bg-gray-300 rounded-md">
          Cancel
        </button>
        <button type="submit" className="px-4 py-1 text-white rounded-md bg-custom-yellow">
          Save
        </button>
      </div>
    </form>
  );
};

export default EditCartForm;
